import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";
import "imagesloaded";
import { KeenSliderNavigation } from "../../../../scripts/sections/keen-slider-navigation-plugin";

export class ProductGallery {
  private slider: HTMLElement | null;
  private activeIdx: number;
  private wrapper: HTMLElement;
  private container: HTMLElement | null;
  private slides: HTMLElement[] | null;

  constructor(wrapper: HTMLElement) {
    this.slider = null;
    this.activeIdx = 0;
    this.wrapper = wrapper;
    this.container = wrapper.querySelector(".keen-slider");
    this.slides = [
      ...this.container.querySelectorAll<HTMLElement>("product-gallery-slide"),
    ];
  }

  /**
    Builds a new instance of the KeenSlider and assigns it to the slider property of the ProductGallery instance.
  */
  _build = () => {
    const spacingValue = (slidePadding: number, slideGap: number) => {
      return (slidePadding * 2 - slideGap) * -1;
    };
    this.slider = new KeenSlider(
      this.container,
      {
        selector: () => this.slides,
        breakpoints: {
          "(min-width: 1024px)": {
            slides: {
              perView: 0,
              spacing: 0,
            },
          },
        },
        slides: {
          perView: 1,
          spacing: spacingValue(20, 12),
        },
      },
      [
        KeenSliderNavigation({
          arrows: false,
          dots: this.wrapper.querySelector("[data-dots]"),
          wrapper: this.wrapper.querySelector(
            ".keen-slider__navigation-wrapper"
          ),
        }),
      ]
    );
  };

  /**
    Loads videos and reveals them after images are loaded.
  */
  _loadVideos = () => {
    const videos = this.container.querySelectorAll(".product-gallery__video");

    // reveal videos after images are loaded
    videos.forEach((el: HTMLElement) => {
      el.style.opacity = "1";
    });
  };

  _init = () => {
    this._loadVideos();
    this._build();
  };
}
